import React from 'react';

import type { RouteObject } from 'react-router-dom';

const ContractInformation = React.lazy(() => import('./views/Information'));
const ContractAddenda = React.lazy(() => import('./views/Addenda'));
const ContractConsumptionObjects = React.lazy(
  () => import('./views/ConsumptionObjects'),
);
const ContractPlannedVolume = React.lazy(() => import('./views/PlannedVolume'));
const ContractPriceHistory = React.lazy(() => import('./views/PriceHistory'));
const ContractSanctions = React.lazy(() => import('./views/Sanctions'));
const ContractTerms = React.lazy(() => import('./views/ContractTerms'));

export const contractDetailPath = {
  Information: '',
  Addenda: 'addenda',
  ConsumptionObjects: 'consumption-objects',
  PlannedVolume: 'planned-volume',
  PriceHistory: 'price-history',
  Sanctions: 'sanctions',
  Terms: 'terms',
};

export const contractDetailsRoutes: RouteObject[] = [
  {
    index: true,
    element: <ContractInformation />,
  },
  {
    path: contractDetailPath.Addenda,
    element: <ContractAddenda />,
  },
  {
    path: contractDetailPath.ConsumptionObjects,
    element: <ContractConsumptionObjects />,
  },
  {
    path: contractDetailPath.PlannedVolume,
    element: <ContractPlannedVolume />,
  },
  {
    path: contractDetailPath.PriceHistory,
    element: <ContractPriceHistory />,
  },
  {
    path: contractDetailPath.Sanctions,
    element: <ContractSanctions />,
  },
  {
    path: contractDetailPath.Terms,
    element: <ContractTerms />,
  },
];
